module.exports = __webpack_public_path__ + "img/Questionnaire_EN.47a2f063.png";